import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { YearService } from '../../../../shared-components/year/year.service';
import { UserPreferencesService } from '../../../../shared-components/user-preferences/user-preferences.service';
import { SchoolYearSettings } from '../../../../shared-components/year/school-year-settings.model';
import { ReportingService } from '../../reporting.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CourseTerm } from '../../../../student360/student-schedule/course-term.model';
import * as moment from 'moment';
import { ReportV9 } from '../../models/report-v9.model';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { StudentAttachment } from '../../../student-attachment/student-attachment.model';
import { System } from '../../../../shared-components/System';
import { ReportQueueComponent } from '../../report-queue/report-queue.component';
import { ReportParameterV9 } from '../../models/report-parameter-v9.model';
import { User } from '../../../../shared-components/user/user.model';
import { UserService } from '../../../../shared-components/user/user.service';
import { ReportParameters } from '../gradebook-statistical-analysis-report/gradebook-statistical-analysis-report.model';
import { TeacherPreview } from '../../models/teacher-preview.model';


@Component({
    selector: 'teacher-summary-preview',
    templateUrl: './teacher-summary-preview.component.html',
    styleUrls: ['./teacher-summary-preview.component.css'],
})
export class TeacherSummaryPreviewComponent implements OnInit, OnDestroy {
    schoolYearSettings: SchoolYearSettings;
    userPreferences: any;
    currentUser: User;
    reportParameter = new ReportParameterV9();
    ReportParameters = new ReportParameters();
    dataSource: MatTableDataSource<TeacherPreview>;
    thisDialogRef: MatDialogRef<TeacherSummaryPreviewComponent>;
    terms: CourseTerm[] = [];
    selectedTerm = new CourseTerm();
    report: ReportV9;
    ErrorCount: 0;
    parameters = [];
    param = [];
    gridColumns: string[] = ['SelectAll', 'AbbreviatedTitle', 'TeacherName', 'Period', 'TermCode', 'DepartmentCode', 'SubjectCode', 'Section', 'RoomNumber', 'DaysGroupDescription'];
    // ERROR HANDLING
    // form: Form;
    errors: ErrorList[] = [];
    public numberMask = {};
    teacherUserId = 0;
    // @ViewChild('Week1Date', { read: ElementRef }) week1Date: ElementRef;
    // @ViewChild('Week2Date', { read: ElementRef }) week2Date: ElementRef;
    @ViewChild('Select', { read: ElementRef }) select: ElementRef;
    @ViewChild('FromPeriod', { read: ElementRef, static: true }) fromPeriod: ElementRef;
    @ViewChild('ToPeriod', { read: ElementRef, static: true }) toPeriod: ElementRef;
    isDataExist = false;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        TeacherSummaryPreviewDialogRef: MatDialogRef<TeacherSummaryPreviewComponent>,
        private dialog: MatDialog,
        private loginService: LoginService,
        private yearService: YearService,
        private userPreferencesService: UserPreferencesService,
        private reportingService: ReportingService,
        private userService: UserService,
    ) {
        this.thisDialogRef = TeacherSummaryPreviewDialogRef;
        this.report = data.Report;
    }

    ngOnInit() {
        this.numberMask = this.reportingService.getNumberMask();
        this.currentUser = this.userService.currentUser;
        // this.getUserPreferences(); // no preferences for this report in JS app
        this.getSchoolYearSettings();

        // set defaults
        this.reportParameter.ToPeriod = 9;
        this.reportParameter.FromPeriod = 0;
        const today = new Date();
        const todayDate = moment(today).format('MM/DD/YYYY');
        this.reportParameter.AttendanceDate = todayDate;
        this.reportParameter.ReportTitle = 'Teacher Summary Preview: ' + todayDate;
        this.reportParameter.PrintDate = todayDate;

    }
    ngOnDestroy() {

    }
    changeTerm(term: CourseTerm) {

        this.selectedTerm = term;
        this.reportParameter.TermId = this.selectedTerm.Id;
    }

    getTermsforCourses() {
        this.terms = [];
        this.reportingService.getTermsforCourses(0, this.yearService.defaultYear.SiteYearId).subscribe(results => {

            // userModel.defaultUserSchoolYear.SchoolYearId

            this.terms = results.filter(function (element) { return (element.TermTypeId != 2); });
            this.terms.push({ $id: null, EndDate: '', Id: -1, LongDescription: "Today's Only", MediumDescription: '', ParentId: null, Sequence: null, ShortDescription: null, StartDate: null, TermTypeId: null, Code: '' });
            this.terms.push({ $id: null, EndDate: '', Id: 0, LongDescription: 'All Terms', MediumDescription: '', ParentId: null, Sequence: null, ShortDescription: null, StartDate: null, TermTypeId: null, Code: '' });
            // set default to today's
            this.selectedTerm = this.terms.find(o => o.Id == -1);
            this.refreshGrid();
            // })
            // .error(function () {
            // })
            // .then(function () {
            // });
        });
    }


    getUser() {

        this.loginService.getUser()
    }
    getSchoolYearSettings() {
        this.yearService.getSchoolYearSettings(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(data => {
            this.schoolYearSettings = data;
            this.reportParameter.isValueChange = false;
            this.reportParameter.isReportList = false;
            // this.setReportTitle();
            this.reportParameter.TermId = -1;
            this.reportParameter.PrintComment = false;
            this.reportParameter.PrintAdds = false;
            this.getTermsforCourses();
            // this.refreshGrid();
        });
    }
    getUserPreferences() {
        this.userPreferencesService.getUserPreferences(0, '/ClassListAll.aspx').subscribe(results => {
            this.userPreferences = JSON.parse(results[0]);
            if (this.userPreferences != null) {
                this.reportParameter.radValue = (this.userPreferences.pub_blnPrintNoField ? 'radNoField' : (this.userPreferences.pub_blnPrintStudentId ? 'radPrintStudentID' : 'radOtherField'));
                this.reportParameter.SkipLineBetweenStudent = this.userPreferences.pub_blnSkipLinesBetweenStudent;
                this.reportParameter.PrintWithGreyHeading = this.userPreferences.pub_blnPrintWithGreyHeadings;
                this.reportParameter.PrintStudentAbsencesAlreadyEntered = this.userPreferences.pub_blnPrintStudentAbsencesAlreadyEntered;
                this.reportParameter.PrintTeacherSignatureLine = this.userPreferences.pub_blnPrintTeacherSignatureLine;
                if (this.reportParameter.OtherFields != null && this.userPreferences.pub_strOtherField != '') {
                    this.reportParameter.OtherField = this.userPreferences.pub_strOtherField;
                }
            }

        });
    }

    getDynamicPagesReadForStudentLookup() {
        this.reportingService.getDynamicPagesReadForStudentLookup(false).subscribe(results => {
            this.reportParameter.OtherFields = results;
            if (results.length > 0) {
                this.reportParameter.OtherField = results[0].Id;
                if (this.userPreferences != null) {
                    if (this.userPreferences.pub_strOtherField != '') {
                        this.reportParameter.OtherField = this.userPreferences.pub_strOtherField.toString();
                    }
                }
            }
        });
    }
    // setReportTitle() {
    //     if (this.loginService.LoginSettings.State != 'CA') {
    //         if (moment(this.reportParameter.Week1Date).isValid() && moment(this.reportParameter.Week2Date).isValid()) {
    //             this.reportParameter.ReportTitle = 'Weeks of: ' + moment.utc(this.reportParameter.Week1Date).format('MM/DD/YYYY') + ' and ' + moment.utc(this.reportParameter.Week2Date).format('MM/DD/YYYY');
    //         }
    //     } else {
    //         this.reportParameter.ReportTitle = 'Attendance Roster Verification';
    //     }
    // }

    changeValue() {
        this.reportParameter.isValueChange = true;
        if (this.reportParameter.FromPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.FromPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
            this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
        }
        if (this.reportParameter.ToPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.ToPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
            this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;
        }
    }
    cancelShowReportParameters() {
        this.thisDialogRef.close();
    }

    refreshGrid() {
        this.errors = [];
        if ((this.reportParameter.FromPeriod == undefined || this.reportParameter.FromPeriod == 0 || this.reportParameter.FromPeriod == null) && $.isNumeric(this.reportParameter.FromPeriod) == false) {
            this.errors.push({
                fieldName: 'From Period',
                errorMsg: 'Field is required',
                fieldRef: this.fromPeriod
            });
        }
        if ((this.reportParameter.ToPeriod == undefined || this.reportParameter.ToPeriod == 0 || this.reportParameter.ToPeriod == null) && $.isNumeric(this.reportParameter.ToPeriod) == false) {
            this.errors.push({
                fieldName: 'To Period',
                errorMsg: 'Field is required',
                fieldRef: this.toPeriod
            });
        }
        if (this.errors.length == 0) {
            this.reportParameter.ReportGridData = [];

            // var attDate = new Date(this.reportParameter.AttendanceDate)
            // attDate.toString();
            this.reportParameter.AttendanceDate = moment(this.reportParameter.AttendanceDate).format('MM/DD/YYYY');


            this.reportingService.getTeacherPreviewGridData(this.yearService.defaultYear.SiteYearId, this.reportParameter.TermId, moment.utc(this.reportParameter.AttendanceDate, 'MM-DD-YYYY HH:mm a').toDate(), this.reportParameter.FromPeriod, this.reportParameter.ToPeriod).subscribe(results => {
                this.reportParameter.ReportGridData = results;
                if (this.reportParameter.ReportGridData.length > 0) {
                    this.isDataExist = true;
                }
                else {
                    this.isDataExist = false;
                }
                this.reportParameter.isValueChange = false;
                this.dataSource = new MatTableDataSource(this.reportParameter.ReportGridData);
                this.reportParameter.selectAllReportGridData = true;
                this.selectAll(true);
            });
        }
    }

    selectAll(value) {
        this.reportParameter.ReportGridData.forEach(o => {
            o.Select = value;
        }
        );
    }

    selectClass() {
        const result = this.reportParameter.ReportGridData.filter(o => o.Select == false);
        if (result.length > 0) {
            this.reportParameter.selectAllReportGridData = false;
        }
        else if (result.length == 0) {
            this.reportParameter.selectAllReportGridData = true;
        }
    }

    runClick() {
        const selectedGridData = this.reportParameter.ReportGridData.filter(o => o.Select);
        if (selectedGridData.length == 0) {
            this.errors.push({
                fieldName: '',
                errorMsg: 'No Rosters Selected!',
                fieldRef: this.select
            });
        }
        if (this.reportParameter.isValueChange) {
            this.errors.push({
                fieldName: '',
                errorMsg: '<span><a style="cursor:pointer;text-decoration:underline;text-wrap:none;white-space: nowrap;">Selection Criteria Changed </a>  Please click Update Display button again!<span>',
                fieldRef: null
            });
        }
        if (this.errors.length == 0) {
            let sectionIds = '';
            selectedGridData.forEach((el, i) => {
                if (sectionIds == '') {
                    sectionIds += selectedGridData[i].SiteSectionId;
                } else {
                    sectionIds = sectionIds + ',' + selectedGridData[i].SiteSectionId;
                }
                this.ReportParameters.SiteSectionIds = sectionIds;
            });

            let workflowReport = false;

            // if user is teacher then set Id
            if (this.currentUser.UserIsTeacher) {
                this.teacherUserId = this.currentUser.Id;
            }

            // this.reportParameter.PrintDate = moment.utc(this.reportParameter.PrintDate, 'MM-DD-YYYY').toString();

            // this.saveUserPreferences();
            this.parameters = [];
            this.param = [];
            this.param.push({ ParamName: 'strReportDate', ParamStringValue: this.reportParameter.PrintDate });
            this.param.push({ ParamName: 'strReportSiteHeader', ParamStringValue: this.yearService.defaultYear.SchoolName });
            this.param.push({ ParamName: 'strReportTitle', ParamStringValue: this.reportParameter.ReportTitle });
            this.param.push({ ParamName: 'strSiteYearCode', ParamStringValue: this.yearService.defaultYear.SchoolCode + '' + this.yearService.defaultYear.AYIdentifier });
            this.param.push({ ParamName: 'lngSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });

            this.param.push({ ParamName: 'strSiteSectionIds', ParamStringValue: this.ReportParameters.SiteSectionIds });
            this.param.push({ ParamName: 'datCurrentAttendanceDate', ParamStringValue: this.reportParameter.AttendanceDate }); // get from parameter
            this.param.push({ ParamName: 'blnPrintAdds', ParamStringValue: this.reportParameter.PrintAdds });
            this.param.push({ ParamName: 'blnPrintComment', ParamStringValue: this.reportParameter.PrintComment });


            this.parameters.push(JSON.stringify(this.param));
            if (workflowReport) {
                this.reportingService.runV9Report(this.report.ReportName, this.report.ReportType, workflowReport, this.parameters).subscribe(response => {
                    setTimeout(() => {
                        this.reportQueueList();
                    }, 500);
                }
                    , err => {
                        // On Error
                        console.log(err);
                    });
            } else {
                const studentAttachment: StudentAttachment = {
                    DocumentId: 0,
                    DocumentName: this.report.ReportName,
                    DocumentBase64: '',
                    DocumentMimeType: '',
                    DocumentModuleName: '',
                    ReportParameters: this.parameters,
                    ReportType: this.report.ReportType
                };
                window.localStorage.setItem('studentAttachment', JSON.stringify(studentAttachment));
                window.open(System.baseUrl + 'studentattachment', '_blank');
            }
            this.thisDialogRef.close();
        }
    } // end run click

    saveUserPreferences() {
        const UserPreferencesObj = this.userPreferences;
        UserPreferencesObj.pub_blnPrintNoField = (this.reportParameter.radValue == 'radNoField' ? true : false);
        UserPreferencesObj.pub_blnPrintStudentId = (this.reportParameter.radValue == 'radPrintStudentID' ? true : false);
        UserPreferencesObj.pub_blnPrintOtherField = (this.reportParameter.radValue == 'radOtherField' ? true : false);
        if (this.reportParameter.OtherField != '') {
            UserPreferencesObj.pub_strOtherField = this.reportParameter.OtherField;
        }
        UserPreferencesObj.pub_blnSkipLinesBetweenStudent = this.reportParameter.SkipLineBetweenStudent;
        UserPreferencesObj.pub_blnPrintWithGreyHeadings = this.reportParameter.PrintWithGreyHeading;
        UserPreferencesObj.pub_blnPrintStudentAbsencesAlreadyEntered = this.reportParameter.PrintStudentAbsencesAlreadyEntered;
        UserPreferencesObj.pub_blnPrintTeacherSignatureLine = this.reportParameter.PrintTeacherSignatureLine;
        const xmlStream: string[] = [];
        xmlStream.push(JSON.stringify(UserPreferencesObj));
        this.userPreferencesService.saveUserPreferences(0, '/ManualEntryRosters.aspx', xmlStream, 0, '').subscribe(response => { }
            , err => {
                // On Error
                console.log(err);
            });
    }
    reportQueueList() {
        const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
        });
    }
} // end class
